import { Flex, Icon, Text } from 'pounceV2';
import React from 'react';
import { useTheme } from '@mui/material';
import { getFlowChartColors } from '../../constantsV3';

const AbsentTagV3 = () => {
  const theme = useTheme();
  const FLOW_CHART_COLORS = getFlowChartColors(theme.palette.tokens);
  return (
    <Flex direction="row" align="center" gap={1}>
      <Icon color={FLOW_CHART_COLORS.SECONDARY_TEXT} size="small" type="close-outline" p={0} />
      <Text variant="body/sm" color={FLOW_CHART_COLORS.SECONDARY_TEXT}>
        Must be Absent
      </Text>
    </Flex>
  );
};

export default AbsentTagV3;
